/* Scheda prodotto De.Cor.Interni: aggiunta rapida al carrello e preferiti (salvati nel browser) */
(function () {
  if (window.__dcCard) return;
  window.__dcCard = true;
  var KEY = 'dci_preferiti_v1';
  var SYNC = 'dci_preferiti_sync';
  var FID = '__preferiti__'; // voce riservata nella scheda cliente (stesso servizio dei progetti boiserie)
  var CID = window.dcCustomerId ? String(window.dcCustomerId) : '';
  var BASE = (window.dcProxy || '/apps/boiserie').replace(/\/$/, '');
  var MAX = 100;

  function favs() {
    try { var v = JSON.parse(window.localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function saveFavs(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) { /* ignore */ }
  }
  function paint() {
    var list = favs();
    document.querySelectorAll('[data-dcp-fav]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-dcp-fav')) >= 0;
      b.setAttribute('aria-pressed', String(on));
      var t = on ? 'Togli dai preferiti' : 'Aggiungi ai preferiti';
      b.setAttribute('aria-label', t);
      b.title = t;
    });
    document.querySelectorAll('[data-dc-fav-count]').forEach(function (n) {
      n.textContent = list.length;
      n.hidden = !list.length;
    });
  }

  /* ---- account: se il cliente ha fatto l'accesso i preferiti stanno nella sua scheda e lo seguono su ogni dispositivo ---- */
  function enc(list) {
    return btoa(unescape(encodeURIComponent(JSON.stringify(list)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function dec(code) {
    try {
      var s = String(code).replace(/-/g, '+').replace(/_/g, '/');
      var v = JSON.parse(decodeURIComponent(escape(atob(s + '==='.slice((s.length + 3) % 4)))));
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) { return []; }
  }
  function flag(v) {
    try {
      if (v === undefined) return window.localStorage.getItem(SYNC) || '';
      if (v) window.localStorage.setItem(SYNC, v); else window.localStorage.removeItem(SYNC);
    } catch (e) { /* ignore */ }
    return '';
  }
  function push() {
    if (!CID) return Promise.resolve(false);
    var now = Date.now();
    return fetch(BASE + '/progetti', {
      method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ action: 'save', project: { id: FID, name: FID, code: enc(favs()), created: now, updated: now } }),
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  function sync(force) {
    if (!CID) {
      // uscita dall'account: i preferiti restano nell'account, non sul dispositivo
      if (flag()) { flag(null); saveFavs([]); paint(); document.dispatchEvent(new CustomEvent('dc:favs-sync')); }
      return Promise.resolve('guest');
    }
    try {
      var last = Number(window.sessionStorage.getItem(SYNC) || 0);
      if (!force && flag() === CID && Date.now() - last < 120000) return Promise.resolve('fresh');
    } catch (e) { /* ignore */ }
    return fetch(BASE + '/progetti', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.ok) return 'off';
        var rec = (d.projects || []).filter(function (p) { return p.id === FID; })[0];
        var server = rec ? dec(rec.code) : [];
        var local = favs();
        var merged;
        if (rec && flag() === CID) merged = server; // già allineato: vale l'account (anche per ciò che è stato tolto altrove)
        else merged = local.concat(server.filter(function (h) { return local.indexOf(h) < 0; })); // primo accesso: unisce
        merged = merged.slice(0, MAX);
        var changed = JSON.stringify(merged) !== JSON.stringify(local);
        saveFavs(merged);
        flag(CID);
        try { window.sessionStorage.setItem(SYNC, String(Date.now())); } catch (e) { /* ignore */ }
        if (!rec || JSON.stringify(merged) !== JSON.stringify(server)) push();
        paint();
        if (changed) document.dispatchEvent(new CustomEvent('dc:favs-sync'));
        return 'ok';
      })
      .catch(function () { return 'off'; });
  }
  window.dcFavs = { list: favs, paint: paint, sync: sync, logged: !!CID };

  function addToCart(btn) {
    var label = btn.querySelector('span');
    var old = label.textContent;
    var notif = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(btn.getAttribute('data-dcp-add')), quantity: 1 }] };
    var ids = notif && typeof notif.getSectionsToRender === 'function' ? notif.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'];
    body.sections = ids;
    body.sections_url = window.location.pathname;
    btn.disabled = true;
    label.textContent = 'Aggiungo…';
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url.replace('.js.js', '.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'Errore');
        var done = false;
        if (notif && typeof notif.renderContents === 'function' && res.sections) {
          var last = res.items && res.items[res.items.length - 1];
          if (last) { res.key = last.key; res.id = last.id; }
          try { notif.renderContents(res); done = true; } catch (err) { /* ignore */ }
          if (notif.classList && notif.classList.contains('is-empty')) notif.classList.remove('is-empty');
        }
        if (!done && res.sections && res.sections['cart-icon-bubble']) {
          var holder = document.getElementById('cart-icon-bubble');
          var tmp = document.createElement('div');
          tmp.innerHTML = res.sections['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section');
          if (holder && inner) holder.innerHTML = inner.innerHTML;
        }
        btn.classList.add('is-done');
        label.textContent = 'Aggiunto ✓';
        setTimeout(function () { btn.classList.remove('is-done'); label.textContent = old; btn.disabled = false; }, 1800);
      })
      .catch(function (err) {
        label.textContent = (err && err.message && err.message.length < 60) ? err.message : 'Non disponibile';
        setTimeout(function () { label.textContent = old; btn.disabled = false; }, 2600);
      });
  }

  document.addEventListener('click', function (e) {
    var fav = e.target.closest && e.target.closest('[data-dcp-fav]');
    if (fav) {
      e.preventDefault();
      var h = fav.getAttribute('data-dcp-fav');
      var list = favs();
      var i = list.indexOf(h);
      if (i >= 0) list.splice(i, 1); else list.unshift(h);
      saveFavs(list);
      paint();
      push();
      document.dispatchEvent(new CustomEvent('dc:favs', { detail: { handle: h, on: i < 0 } }));
      return;
    }
    var add = e.target.closest && e.target.closest('[data-dcp-add]');
    if (add && !add.disabled) { e.preventDefault(); addToCart(add); }
  });

  var t;
  function later() { clearTimeout(t); t = setTimeout(paint, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
  sync(false);
  // le schede caricate dopo (scorrimento infinito, filtri, consigliati) prendono lo stato dei preferiti
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { later(); break; }
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });
})();
